import { render, staticRenderFns } from "./PrintCard.vue?vue&type=template&id=7c317246&scoped=true"
import script from "./PrintCard.vue?vue&type=script&lang=js"
export * from "./PrintCard.vue?vue&type=script&lang=js"
import style0 from "./PrintCard.vue?vue&type=style&index=0&id=7c317246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c317246",
  null
  
)

export default component.exports